import React from "react";

import {
    InThePressHeroBanner,
    InThePressRecentNews,
    InThePressMediaKitDownloadWidget,
    InThePressArchives,
} from "pageComponents/press";

import SEO from "components/seo";
import Layout from "components/Layout/Layout";

const InThePress = () => (
    <Layout>
        <SEO
            title="PhonePe - Press Stories"
            description="Read what the press has to say about PhonePe! Find online and press media stories, latest press releases, logo &amp; other assets and our news archives. Learn more about new launches, funding news and other news announcements. "
            url="https://www.phonepe.com/press/"
        />
        <InThePressHeroBanner />
        <InThePressRecentNews />
        <InThePressMediaKitDownloadWidget />
        <InThePressArchives />
    </Layout>
);

export default InThePress;
